import { HttpData, HttpNoData } from "../../../../Core";

export async function updateShiftAsync(id, body, jwt) {

    const response = await HttpData(`/api/v1/shifts/${id}`, 'PUT', jwt, body);

    return response.data;
}
export const createShiftAsync = async (body, jwt) => {

    const response = await HttpData(`/api/v1/shifts/create`, 'POST', jwt, body)

    if (!response.statusSuccessful) console.log(response.error)

    return response.data
}

export async function getWorkersV1(jwt) {
    const response = await HttpNoData('/api/v1/workers', 'GET', jwt);

    if (!response.statusSuccessful) console.log(response.error)

    return response.data
}

export async function getExtraWorksV1(jwt) {
    const response = await HttpNoData('/api/v1/ExtraWorks', 'GET', jwt)

    if (!response.statusSuccessful) console.log(response.error)

    return response.data
}

export async function getExtraWorkCategoriesV1(jwt) {

    const response = await HttpNoData('/api/v1/extraWorkCategories', 'GET', jwt);

    if (!response.statusSuccessful)
        console.log(response.error);

    return response.data;
}

export async function getShiftsAllV1(date, jwt) {

    const response = await HttpNoData('/api/v1/shifts/all/history?date=' + date, 'GET', jwt);

    if (!response.statusSuccessful)
        console.log(response.error);

    return response.data;
}

export async function getShiftsMyV1(date, jwt) {

    const response = await HttpNoData('/api/v1/shifts/history?date=' + date, 'GET', jwt);

    if (!response.statusSuccessful)
        console.log(response.error);

    return response.data;
}

export const deleteExtraWorkPull = async (jwt, id) => {
    const response = await HttpNoData(`/api/v1/ExtraWorkPulls/${id}`, 'DELETE', jwt)

    if (!response.statusSuccessful) console.log(response.error)

    return response.statusSuccessful
}

export const createExtraWorkPull = async (jwt, body) => {

    const response = await HttpData(`/api/v1/ExtraWorkPulls`, 'POST', jwt, body)

    if (!response.statusSuccessful) console.log(response.error)

    return response.data
}

export const updateExtraWorkPull = async (jwt, id, body) => {

    const response = await HttpData(`/api/v1/ExtraWorkPulls/${id}`, 'PUT', jwt, body)

    if (!response.statusSuccessful) console.log(response.error)

    return response.statusSuccessful
}

export async function getWorkersCategories(jwt) {
    const response = await HttpNoData('/api/v1/workers/categories', 'GET', jwt);

    if (!response.statusSuccessful) console.log(response.error)

    return response.data
}

export async function getWorkersTypes(jwt) {
    const response = await HttpNoData('/api/v1/workers/types', 'GET', jwt);

    if (!response.statusSuccessful) console.log(response.error)

    return response.data
}

export async function getWorkersEmploymentTypes(jwt) {
    const response = await HttpNoData('/api/v1/workers/employmentTypes', 'GET', jwt);

    if (!response.statusSuccessful) console.log(response.error)

    return response.data
}

export async function getWorkersQualificationTypes(jwt) {
    const response = await HttpNoData('/api/v1/workers/qualificationTypes', 'GET', jwt);

    if (!response.statusSuccessful) console.log(response.error)

    return response.data
}

export async function getMathSalaries(jwt) {
    const response = await HttpNoData('/api/v1/workers/mathSalaries', 'GET', jwt);

    if (!response.statusSuccessful) console.log(response.error)

    return response.data
}